export { default } from './withWidth';
export * from './withWidth';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/withWidth/index.js
// module id = 419
// module chunks = 2